import * as React from "react";

import SwapTrackerList from "./swap-tracker-list";

interface IOneWayTrackerProps {
    isOps: boolean,
    reloadCounts: Function
}

class SwapTracker extends React.Component<IOneWayTrackerProps, {}> {
    componentWillMount = () => {
        document.title = "NKR Admin: Swap Tracker"
    }

    handleReloadCounts = () => {
        if (this.props.reloadCounts != null)
            this.props.reloadCounts();
    }

    render() {
        return (
            <div style={{ paddingTop: 0 }}>
                <SwapTrackerList
                    isOps={this.props.isOps}
                    reloadCounts={this.handleReloadCounts}
                />
            </div>
        );
    }
}

export default SwapTracker;